import { PROCESS } from "../../data/content";
import { Reveal } from "./Reveal";

export const Process = () => {
  return (
    <section id="process" data-testid="process-section" className="surface-light py-24 lg:py-36">
      <div className="mx-auto w-[92%] max-w-[1280px]">
        <div className="max-w-2xl mb-14">
          <Reveal>
            <span className="font-mono text-[12px] font-bold uppercase tracking-[0.25em] text-accent">Our Process</span>
          </Reveal>
          <Reveal delay={0.05}>
            <h2 className="mt-5 font-display font-semibold tracking-tighter leading-[0.95] text-4xl md:text-6xl text-fc-ink">
              Simple. Professional. Straightforward.
            </h2>
          </Reveal>
        </div>

        <div className="grid md:grid-cols-4 border-t border-fc-ink/10">
          {PROCESS.map((p, i) => (
            <Reveal key={p.n} delay={i * 0.08}>
              <div className="border-b md:border-b-0 md:border-r border-fc-ink/10 last:border-r-0 p-8 h-full">
                <div className="font-display text-5xl font-semibold tracking-tighter text-accent">{p.n}</div>
                <h3 className="mt-6 font-display text-2xl tracking-tight text-fc-ink">{p.title}</h3>
                <p className="mt-2 text-fc-ink2 text-sm">{p.desc}</p>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
};
